var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V4H8L9.5 2.5C8.5 1.5 7.25 1 5.75 1C3.5 1 1.5 2.75 1 5H0L2.5 7.5L5 5H3.5C3.75 3.5 4.75 2.5 6 2.5C6.75 2.5 7.25 2.75 7.75 3.25L10 2ZM2 10V8H4L2.5 9.5C3.5 10.5 4.75 11 6.25 11C8.5 11 10.5 9.25 11 7H12L9.5 4.5L7 7H8.5C8.25 8.5 7.25 9.5 6 9.5C5.25 9.5 4.75 9.25 4.25 8.75L2 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.025af804a86718db09a27a12ce975e21.svg";
export { ForwardRef as ReactComponent };